import {isEqual, sum, values} from 'lodash'
import {Basic} from 'types'

/**
 * Helper to extract values from unit counter map
 */
const getUnitCounterValues = (unitCounters?: Basic.UnitCounterMap) => {
  return unitCounters ? values(unitCounters) : []
}

/**
 * Check if any guests are selected in unit counters
 */
export const hasGuests = (unitCounters?: Basic.UnitCounterMap): boolean => {
  return getTotalGuests(unitCounters) > 0
}

/**
 * Compare two unit counter maps for equality
 */
export const areUnitCountersEqual = (a?: Basic.UnitCounterMap, b?: Basic.UnitCounterMap): boolean => {
  return isEqual(a, b)
}

/**
 * Get total number of guests across all unit types
 */
export const getTotalGuests = (unitCounters?: Basic.UnitCounterMap): number => {
  return sum(getUnitCounterValues(unitCounters))
}
